import { reactive } from 'vue';
import { api } from '@/utils/api';

const state = reactive({
    actions: null,
    loading: false
});

async function loadActions() {
    if (state.loading) return;
    state.loading = true;

    try {
        const response = await api.get('/agent/tools');
        state.actions = {};
        for (const tool of response.data) {
            state.actions[tool.name] = tool.displayName;
        }
    } catch (error) {
        console.error('Failed to load actions:', error);
        state.actions = {};
    } finally {
        state.loading = false;
    }
}

export const getActionName = (action) => {
    if (!state.actions && !state.loading) {
        loadActions();
    }
    if (state.actions) {
        return state.actions[action] || action;
    }
    return action;
}
